module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/pie-chart/pie-chart.component.less
// module id = ./src/app/shared/components/chart/pie-chart/pie-chart.component.less
// module chunks = main